<template>
  <div class="card-preview">
    <card-logo :brand="card.card_brand" class="card-preview__brand" />
    <span class="card-preview__text">
      <span v-if="card.card_type === 'credit_card'">Cartão de crédito</span>
      <span class="card-preview__brand-name">{{ card.card_brand }}</span>
      <span>de final</span>
      <strong>{{ card.last_digits }}</strong>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.card-preview {
  align-items: center;
  display: flex;
}

.card-preview__brand {
  height: 24px;
  margin-right: var(--space-extra-small);
  max-width: 35px;
}

.card-preview__text {
  color: var(--color-neutral-black);
  font-size: rem(16);
  line-height: rem(24);
}

.card-preview__brand-name {
  text-transform: capitalize;
}
</style>

<script>
import CardLogo from 'components/card-logo';

export default {
  props: {
    card: {
      required: true,
      type: Object,
    },
  },
  components: {
    CardLogo,
  },
};
</script>
